import Image from "next/image";
import Markdown from "markdown-to-jsx/react";
import DOMPurify from "isomorphic-dompurify";

import SectionTitle from "components/typography/SectionTitle/SectionTitle";
import styles from "./PageIntro.module.scss";

export default function PageIntro({
  title,
  description,
  image,
  layout,
  actions,
}) {
  return (
    <section
      className={`${styles.pageIntroContainer} ${
        layout && image ? styles[layout] : ""
      }`}
    >
      {title && (
        <h1 className={`${styles.title}`}>
          <SectionTitle title={title}></SectionTitle>
        </h1>
      )}
      {description && (
        <div className={`${styles.description}`}>
          <Markdown className={`${styles.pageIntroduction}`}>
            {DOMPurify.sanitize(description)}
          </Markdown>
        </div>
      )}

      {image && (
        <div className={`${styles.imageContainer}`}>
          <div className={`${styles.image}`}>
            <Image
              src={image}
              fill
              alt={`Image of ${title ?? "unknown"}`}
              loading={"eager"}
            />
          </div>
        </div>
      )}

      {actions && <div className={`${styles.actions}`}>{actions}</div>}
    </section>
  );
}
